import * as ewe from "@eyeo/webext-ad-filtering-solution";
import browser from "webextension-polyfill";
import { DialogAction, } from "../shared/types.js";
import { ValidationReason } from "../shared/validation-reasons.js";
import { isUrlAllowed } from "./url-allowlist.js";
const VARIABLE_PATTERN = /\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g;
const serverLogger = new ewe.telemetry.ServerLogger("reverse_trial");
function resolveVariables(template, vars, encode) {
    return template.replace(VARIABLE_PATTERN, (match, name) => {
        if (!Object.prototype.hasOwnProperty.call(vars, name)) {
            return match;
        }
        return encode ? encodeURIComponent(vars[name]) : vars[name];
    });
}
export function resolveUrlVariables(url, vars) {
    return resolveVariables(url, vars, true);
}
export function resolveTextVariables(text, vars) {
    return resolveVariables(text, vars, false);
}
export function resolveI18nText(i18n, key, locale) {
    var _a, _b, _c, _d;
    const exact = (_a = i18n[locale]) === null || _a === void 0 ? void 0 : _a[key];
    if (typeof exact === "string") {
        return exact;
    }
    const language = locale.split(/[-_]/)[0];
    const base = (_b = i18n[language]) === null || _b === void 0 ? void 0 : _b[key];
    if (typeof base === "string") {
        return base;
    }
    return (_d = (_c = i18n.en) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : "";
}
export function resolveActionUrl(action, templateVars, allowedUrlHosts) {
    if (action.type !== DialogAction.NAVIGATE) {
        return "";
    }
    const substituted = resolveUrlVariables(action.url, templateVars);
    if (isUrlAllowed(substituted, allowedUrlHosts)) {
        return substituted;
    }
    let hostname = "";
    try {
        hostname = new URL(substituted).hostname;
    }
    catch (_a) {
    }
    serverLogger.info("config_validation_failed", {
        reason: ValidationReason.URL_VALIDATION_FAILED_AFTER_SUBSTITUTION,
        hostname,
    });
    return "";
}
export async function buildUrlVariables(stepId, trialStartDate, params, isOptedOut) {
    return {
        step: String(stepId),
        trial_start: String(trialStartDate),
        lang: browser.i18n.getUILanguage(),
        addon_version: isOptedOut ? "" : params.addonVersion,
        rcid: isOptedOut ? "" : await ewe.telemetry.getRotatingClientId(),
        revision_id: isOptedOut
            ? ""
            : String(await ewe.remoteConfig.getRevisionId()),
        experiments: isOptedOut
            ? ""
            : await ewe.experiments.getEncodedExperiments(),
        cohorts: isOptedOut ? "" : await ewe.cohorts.getEncodedCohorts(),
    };
}
export function buildTextVariables(config, elapsedDays) {
    return {
        days_elapsed: String(Math.max(0, elapsedDays)),
        days_remaining: String(Math.max(0, config.trialDurationDays - elapsedDays)),
    };
}
